import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TokenizedPaymentCard, CreditCardType } from '@/models';
import moment from 'moment';

@Component({
  name: 'CmgCreditCard',
})
export default class CmgCreditCard extends Vue {
  isRemovingCard = false;

  @Prop({ required: true, type: Object })
  token!: TokenizedPaymentCard;

  @Prop({ required: false, default: true, type: Boolean })
  showRemoveButton?: boolean;

  get creditCardLogoUrl(): string {
    switch (this.token.paymentMethod) {
      case CreditCardType.Visa:
        return this.$appStore.state.cms.images.logos.visaLogo.default;
      case CreditCardType.Mastercard:
        return this.$appStore.state.cms.images.logos.mastercardLogo.default;
      case CreditCardType.Amex:
        return this.$appStore.state.cms.images.logos.amexLogo.default;
      case CreditCardType.Discover:
        return this.$appStore.state.cms.images.logos.discoverCardLogo.default;
      default:
        return this.$appStore.state.cms.images.logos.defaultCardLogo.default;
    }
  }

  get isCardExpired(): boolean {
    if (!this.token.expiration) {
      return true;
    }
    
    if (this.token.expirationMonth && this.token.expirationYear) {
      const today = moment();
      const expirationDate = moment(`${this.token.expirationMonth}/${this.token.expirationYear}`, 'MM/YY');

      if (today > expirationDate.add(1, 'months')) {
        return true;
      }
    }

    return false;
  }

  get colorOfRemoveButton(): string {
    return this.isCardExpired ? 'red-light' : 'white';
  }

  get creditCardClass(): string {

    if (this.isCardExpired) {
      return 'expired';
    }

    switch (this.token.paymentMethod) {
      case CreditCardType.Visa:
        return 'visa';
      case CreditCardType.Mastercard:
        return 'mastercard';
      case CreditCardType.Amex:
        return 'amex';
      case CreditCardType.Discover:
        return 'discover';
      default:
        return 'default';
    }
  }

  get creditCardNumberMask(): string {
    switch (this.token.paymentMethod) {
      case CreditCardType.Amex:
      case CreditCardType.Discover:
        return 'amex-discover-mask';
      case CreditCardType.Visa:
      case CreditCardType.Mastercard:
      default:
        return 'visa-mastercard-mask';
    }
  }

  get lastFourCreditCardNumbers(): string {
    const accountNumber = this.token.tokenizedAccountNumber;
    return this.token.lastFourAccountNumbers ? this.token.lastFourAccountNumbers : accountNumber.substr(accountNumber.length - 4);
  }

  async onClickRemoveACreditCard(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('removePaymentCardModal', true, { token: this.token });    
    this.$services.ui.firstFocus();
  }
}